module.exports = __webpack_public_path__ + "static/media/free-scrap-removal2.d931e9e2.png";